'use client';
import React from "react";
import {clsx} from "clsx";
import IMG from "../../constants/image";
import ImageBasic from "../Common/Image/ImageBasic";
import {useLocation} from "react-router-dom";
import {PATH} from "../../constants";

export const Logo = ({url, className, title}) => {
    const location = useLocation();
    const pathname = location.pathname;
    return (
        <div className={clsx("flex items-center justify-center space-x-4 cursor-pointer")}>
            <ImageBasic
                className={`${className} max-w-[175px]`}
                src={url || IMG.logoDark}
                alt="Grocery cart white"
            />
            {title && pathname !== PATH.LOGIN && (
                <div className='text-sm text-black font-bold border-l-2 border-black pl-4'>{title}</div>)}
        </div>
    );
};
